// import http from "./http";

// /* =========================
//    GET TM USERS
// ========================= */
// export const getTMUsers = async () => {
//   const res = await http.post("tm_sale_all_user?action=tm");
//   return res.data;
// };

// /* =========================
//    GET SALES USERS
// ========================= */
// export const getSalesUsers = async () => {
//   const res = await http.post("tm_sale_all_user?action=sales");
//   return res.data;
// };

// /* =========================
//    ASSIGN SALES TO TM
// ========================= */
// export const assignUserToTM = async (payload) => {
//   const res = await http.post("assignUserToTM", payload, {
//     headers: {
//       "Content-Type": "application/json",
//     },
//   });
//   return res.data;
// };


import http from "./http";

/* =========================
   GET TEAM MANAGERS
========================= */
export const getTMUsers = async () => {
  const res = await http.post("tm_sale_all_user?action=tm");
  return res.data;
};

/* =========================
   GET SALES USERS
========================= */
export const getSalesUsers = async () => {
  const res = await http.post("tm_sale_all_user?action=sales");
  return res.data;
};

/* =========================
   ASSIGN / MERGE SALES TO TM
========================= */
export const assignUserToTM = async (payload) => {
  const res = await http.post("assignUserToTM", payload);
  return res.data;
};

/* =========================
   GET TEAM LIST / SINGLE
========================= */
export const getAssignedTeams = async (tm_id = null) => {
  const url = tm_id ? `assignUserToTM?tm_id=${tm_id}` : "assignUserToTM";
  const res = await http.get(url);
  return res.data;
};


/* =========================
   UPDATE TEAM SALES
========================= */
export const updateTeamSales = async (payload) => {
  const res = await http.put("assignUserToTM", payload);
  return res.data;
};



/* =========================
   REMOVE SINGLE SALES
========================= */
export const removeSalesFromTM = async (payload) => {
  const res = await http.delete("assignUserToTM", { data: payload });
  return res.data;
};

/* =========================
   DELETE FULL TEAM
========================= */
export const deleteTeamMapping = async (payload) => {
  const res = await http.delete("assignUserToTM", { data: payload });
  return res.data;
};





/* =========================
   GET SALES USERS BY TM
========================= */
export const getSalesByTM = async (tm_id) => {
  const res = await http.get(`get_tm_users?tm_id=${tm_id}`);
  return res.data;
};


// export const getTMUsers = async () => {
//   const res = await http.post("tm_sale_all_user?action=tm");
//   return res.data;
// };

// ✅ NEW (using your existing API)
export const getSalesUsersByTM = async (tm_id) => {
  const res = await http.get(`get_tm_users?tm_id=${tm_id}`);
  return res.data;
};